var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettingsHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_over",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_212",
    "data-name": "Rect\\xE1ngulo 212",
    width: 34,
    height: 34,
    transform: "translate(834 790)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_31",
    "data-name": "Rect\\xE1ngulo 31",
    width: 29.022,
    height: 29.028,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_26",
    "data-name": "Enmascarar grupo 26",
    transform: "translate(-834 -790)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    transform: "translate(836.416 792.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M15.963,29.028h-2.9c-.074-.025-.146-.056-.222-.074a2.82,2.82,0,0,1-2.2-2.757.941.941,0,0,0-1.653-.7,2.823,2.823,0,0,1-4.065-.045c-.46-.452-.917-.907-1.366-1.37a3.37,3.37,0,0,1-.434-.54,2.814,2.814,0,0,1,.368-3.479,1,1,0,0,0,.356-.914.928.928,0,0,0-.979-.763A2.838,2.838,0,0,1,0,15.473c0-.655-.005-1.31,0-1.965a2.828,2.828,0,0,1,2.828-2.857A.94.94,0,0,0,3.526,9,2.825,2.825,0,0,1,3.577,4.93c.445-.452.894-.9,1.35-1.343a3.581,3.581,0,0,1,.562-.455,2.823,2.823,0,0,1,3.523.408.9.9,0,0,0,1.455-.083,1.369,1.369,0,0,0,.17-.655,2.851,2.851,0,0,1,2.837-2.8C14.148,0,14.824,0,15.5.005a2.827,2.827,0,0,1,2.879,2.837.94.94,0,0,0,1.659.689,2.824,2.824,0,0,1,4.065.052c.453.445.9.892,1.345,1.348a3.517,3.517,0,0,1,.454.563A2.819,2.819,0,0,1,25.506,9a.96.96,0,0,0-.324.922.93.93,0,0,0,1.006.73A2.839,2.839,0,0,1,28.961,12.9a1.25,1.25,0,0,0,.06.162v2.9c-.05.161-.1.323-.149.482a2.846,2.846,0,0,1-2.713,1.937.924.924,0,0,0-.983.757,1,1,0,0,0,.344.917,2.815,2.815,0,0,1,.05,3.909c-.52.561-1.071,1.094-1.624,1.623a2.635,2.635,0,0,1-1.592.722,2.854,2.854,0,0,1-2.362-.841A.921.921,0,0,0,18.4,25.9a1.89,1.89,0,0,0-.025.36,2.85,2.85,0,0,1-1.963,2.634c-.15.049-.3.092-.454.138M6.955,4.568a3.584,3.584,0,0,0-.653.384c-.439.4-.847.834-1.266,1.255a.946.946,0,0,0-.03,1.541A2.816,2.816,0,0,1,5.8,9.687a2.858,2.858,0,0,1-2.864,2.894.914.914,0,0,0-.995,1c0,.645-.005,1.289,0,1.934a.913.913,0,0,0,.93.943,3.869,3.869,0,0,1,.777.091A2.855,2.855,0,0,1,4.991,21.3a.935.935,0,0,0,.018,1.5q.6.6,1.2,1.2a.945.945,0,0,0,1.541.028,2.786,2.786,0,0,1,1.875-.794,2.85,2.85,0,0,1,2.956,2.858.919.919,0,0,0,1.016,1.006q.921,0,1.843,0a.921.921,0,0,0,1.011-.982,2.865,2.865,0,0,1,4.886-2.034.918.918,0,0,0,1.411-.01q.657-.646,1.3-1.3a.928.928,0,0,0,.015-1.435,2.865,2.865,0,0,1,2.051-4.878.916.916,0,0,0,.97-.992q0-.952,0-1.9a.911.911,0,0,0-.955-.975,2.758,2.758,0,0,1-2.675-1.769,2.743,2.743,0,0,1,.619-3.12.923.923,0,0,0-.013-1.413c-.41-.416-.826-.827-1.239-1.24a.945.945,0,0,0-1.54-.033,2.819,2.819,0,0,1-1.908.793,2.86,2.86,0,0,1-2.927-2.829.927.927,0,0,0-1.053-1.03c-.625,0-1.249,0-1.874,0a.913.913,0,0,0-.946.926,3.922,3.922,0,0,1-.092.777,2.85,2.85,0,0,1-4.73,1.368,1.482,1.482,0,0,0-.8-.443",
    transform: "translate(0 0)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M32.587,39.354a6.771,6.771,0,1,1,6.807,6.787,6.779,6.779,0,0,1-6.807-6.787m11.607.03a4.836,4.836,0,1,0-4.805,4.824,4.843,4.843,0,0,0,4.805-4.824",
    transform: "translate(-24.846 -24.854)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsHover);
export default __webpack_public_path__ + "static/media/icon_settings_hover.cc74850af40d8e197e6da20260edae57.svg";
export { ForwardRef as ReactComponent };